sweetalert.$inject = ['$rootScope', '$q']
export default function sweetalert($rootScope, $q) {
    const self = {
        swal(arg1, arg2, arg3) {
            /** 确认提示组件
            *       text: <String> 必填 提示内容
            *       title: <String> 标题
            *       icon： <String> 提示图标类型 目前有'tishi', 'success', 'warn', 'error'
            * */
            $rootScope.$evalAsync(() => {
                if (typeof (arg1) !== 'object') return
                const opt = {
                    btn: ['确定'],
                    title: arg1.title,
                    message: arg1.text,
                    icon: 'tishi' || arg3,
                }
                let titleHtml = ''
                let iconHtml = ''
                let contentHtml = ''
                opt.btn[0] = arg1.confirmButtonText
                opt.btn[1] = arg1.cancelButtonText
                // 是否有标题
                if (opt.title && typeof opt.title === 'string') {
                    titleHtml = `<div class="message-title">${opt.title}</div>`
                }
                // 是否有icon
                if (opt.icon && typeof opt.icon === 'string') {
                    iconHtml = `<div class="content-left"><i class="icon iconfont icon-${opt.icon} iconfont-${opt.icon}"></i></div>`
                }
                contentHtml = `<div class="layer-msg-content">
                    ${iconHtml}
                    <div class="content-center">
                        ${titleHtml}
                        <div class="message-content">${opt.message}</div>
                    </div>
                </div>`
                layer.open({
                    type: 0,
                    title: false,
                    resize: false,
                    closeBtn: 0,
                    btn: opt.btn,
                    shadeClose: false,
                    skin: 'layer-message-self',
                    content: `${contentHtml}`,
                    yes(index, layero) {
                    // 按钮【按钮一】的回调
                        layer.close(index)
                        if (typeof (arg2) === 'function') {
                            arg2(true)
                        }
                    },
                    btn2(index, layero) {
                    // 按钮【按钮二】的回调
                    // return false 开启该代码可禁止点击该按钮关闭
                    // layer.close(index)
                        if (typeof (arg2) === 'function') {
                            arg2(false)
                        }
                    },
                })
            })
        },

        confirm(title, text) {
            /** 确认提示组件
            *       text: <String> 必填 提示内容
            *       title: <String> 标题
            *       icon： <String> 提示图标类型 目前有'tishi', 'success', 'warn', 'error'
            * */
            const defered = $q.defer()
            if (text === undefined || text === null) return
            const opt = {
                btn: ['确定', '取消'],
                title,
                message: text,
                icon: 'tishi',
            }
            let titleHtml = ''
            let iconHtml = ''
            let contentHtml = ''
            // 是否有标题
            if (opt.title && typeof opt.title === 'string') {
                titleHtml = `<div class="message-title">${opt.title}</div>`
            }
            // 是否有icon
            if (opt.icon && typeof opt.icon === 'string') {
                iconHtml = `<div class="content-left"><i class="icon iconfont icon-${opt.icon} iconfont-${opt.icon}"></i></div>`
            }
            contentHtml = `<div class="layer-msg-content">
                    ${iconHtml}
                    <div class="content-center">
                        ${titleHtml}
                        <div class="message-content">${opt.message}</div>
                    </div>
                </div>`
            layer.open({
                type: 0,
                title: false,
                resize: false,
                closeBtn: 0,
                btn: opt.btn,
                shadeClose: false,
                skin: 'layer-message-self',
                content: `${contentHtml}`,
                yes(index, layero) {
                    // 按钮【按钮一】的回调
                    layer.close(index)
                    defered.resolve()
                },
                btn2(index, layero) {
                    // 按钮【按钮二】的回调
                    // return false 开启该代码可禁止点击该按钮关闭
                    // layer.close(index)
                    defered.reject()
                },
            })
            return defered.promise
        },
    }

    return self
}



// WEBPACK FOOTER //
// ./src/components/sweetalert/sweetalertFactory.js